import {getToken} from '@/utils/auth'
import store from '../../store'
import { IS_RENDERBUS } from '../../utils/const'
export const CONST_HEADER = () => ({
  'x-auth-token': getToken() || '',
  version: '1.0.0',
  signature: 'rayvision2017',
  platform: getplatform(),
  channel: store.getters['home/channel'] || 5,
  languageFlag: (localStorage.getItem('lang') === 'en' ? 1 : 0) || 0,
})

export const CONST_WHITE_LISTS = ['login', 'register', 'forgetpassword']
export const CONST_API_WHITE_LISTS = [
  '/rendering/socket/authSocketConnection',
  '/rendering/task/transfer/getTransferServerMsg',
  '/rendering/task/common/queryPlatforms',
]
export const CONST_RACE_WHITE_LISTS = [
  '/api/rendering/admin/base/danxiaoer/upload/save',
  '/api/rendering/admin/front/material/info/uploadExampleFile',
  '/api/rendering/admin/task/aspera/queryAsperaIps',
  '/api/rendering/admin/task/aspera/addAspera',
  '/api/rendering/admin/task/node/capacity/listMunuNodeCapacity',
  '/api/rendering/admin/task/common/getGlobalSearchList',
  '/api/rendering/admin/front/viewUserInfo',
  '/api/rendering/admin/front/user/cgInfo/query',
  '/api/rendering/admin/task/platform/queryAllByCondition',
  '/api/rendering/admin/task/mirror/queryMirrorConfigs',
  '/api/rendering/admin/task/config/cgDependence/list',
  '/api/rendering/admin/task/node/capacity/listMunuNodeHardware',
]

export const MIRROR_MANAGE_LIST = [
  '/api/rendering/admin/task/mirror/getActiveNodeCount',
  '/api/rendering/admin/task/mirror/queryMirrorConfigs',
  '/api/rendering/admin/task/mirror/deleteMirrorConfig',
  '/api/rendering/admin/task/mirror/addOrUpdateMirrorConfig',
  '/api/rendering/admin/task/mirror/getMirrorName',
  '/api/rendering/admin/task/specialUserMirror/list',
  '/api/rendering/admin/task/specialUserMirror/detail',
  '/api/rendering/admin/task/specialUserMirror/add',
  '/api/rendering/admin/task/specialUserMirror/update',
  '/api/rendering/admin/task/specialUserMirror/delete',
  '/api/rendering/admin/task/specialUserMirror/status',
  '/api/rendering/admin/task/specialUserMirror/imageOptions',
  '/api/rendering/admin/task/specialUserMirror/softwareOptions',
  '/api/rendering/admin/task/specialUserMirror/softwareVersionOptions',
  '/api/rendering/admin/task/mirror/setGlobalConfig',
  '/api/rendering/admin/task/mirror/getGlobalConfig',
]

export function getplatform () {
  const currentPlatform = IS_RENDERBUS ? 0 : 24
  const platformList = store.getters['home/platformList']
  if (!platformList.length) return currentPlatform
  if (platformList.includes(parseInt(sessionStorage.getItem('platform')))) return sessionStorage.getItem('platform')
  store.dispatch('home/updatePlatform', platformList[0] || currentPlatform)
  return platformList[0] || currentPlatform
}

export const ADMIN_SSO_BIZ_CODE = 'rayvision.renderbus'

export function jumpToLogin(includeQuery = true) {
  const origin = window.location.origin
  let loginUrl
  switch (origin) {
    case 'https://admin-pre.renderbus.com':
    case 'https://admin-pre.dayancloud.com':
    case 'https://admin-beta.dayancloud.com':
      loginUrl = 'https://admin-pre.renderbus.com/admin-sso/login'
      break
    case 'https://admin.renderbus.com':
    case 'https://admin.dayancloud.com':
      loginUrl = 'https://admin.renderbus.com/admin-sso/login'
      break
    default:
      loginUrl = origin + '/login'
  }

  if (includeQuery && loginUrl.includes('/admin-sso/login')) {
    const query = [
      `bizCode=${encodeURIComponent(ADMIN_SSO_BIZ_CODE)}`,
      `redirectUri=${encodeURIComponent(window.location.href)}`,
    ].join('&')
    loginUrl = `${loginUrl}?${query}`
  }

  window.location.replace(loginUrl)
}

export const noShowDefaultCodeError = (code, api) => {
  const apiObj = {
    '/api/rendering/admin/task/platform/checkImportPlatformConfigData': [601],
    '/api/rendering/admin/base/login': [100],
  }
  return apiObj[api] && apiObj[api].includes(code)
}
